import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '~/store';

export const tagSelector = (state: RootState) => state.tag;

export const currentTagSelector = createSelector(
  tagSelector,
  (tags) => tags.currentTag,
);
